import { render, staticRenderFns } from "./SharedBoards.vue?vue&type=template&id=8e7de126&scoped=true&"
import script from "./SharedBoards.vue?vue&type=script&lang=ts&"
export * from "./SharedBoards.vue?vue&type=script&lang=ts&"
import style0 from "./SharedBoards.vue?vue&type=style&index=0&id=8e7de126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e7de126",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})
